import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';

const TermsOfServicePage = () => {
  const lastUpdated = 'December 24, 2025';

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-52 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Terms of Service
          </h1>
          <p className="text-slate-400">Last Updated: {lastUpdated}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Agreement to Terms</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                By accessing or using the {companyInfo.name} website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Services Description</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                {companyInfo.name} provides residential construction services including but not limited to new builds, home transformations, additions, and remodeling. All construction services are subject to separate written contracts that will govern the specific terms of each project.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                The information provided on this website is for general informational purposes only. Project estimates, timelines, and specifications discussed through this website are preliminary and subject to change based on detailed project assessments.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Customer Portal</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                We utilize JobTread construction management software to provide our clients with a customer portal. Use of the customer portal is subject to JobTread's terms of service in addition to these terms. The portal is provided as a convenience for project communication and management.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                You are responsible for maintaining the confidentiality of your portal access credentials and for all activities that occur under your account.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Intellectual Property</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                The content on this website, including but not limited to text, graphics, logos, images, photographs of completed projects, and software, is the property of {companyInfo.name} or its content suppliers and is protected by copyright and other intellectual property laws.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                Project photographs displayed in our portfolio may not be reproduced, distributed, or used for any commercial purpose without prior written consent from {companyInfo.name}.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. User Submissions</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                By submitting information through our contact forms, vendor applications, or employment applications, you grant {companyInfo.name} the right to use this information to respond to your inquiry, evaluate your application, and for related business purposes.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                You represent that any information you provide is accurate and complete to the best of your knowledge.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Construction Contracts</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                These Terms of Service do not constitute a construction contract. All construction projects require a separate written agreement that will include specific terms regarding scope of work, pricing, payment schedules, timelines, warranties, and other project-specific details.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                In the event of any conflict between these Terms of Service and a signed construction contract, the construction contract shall prevail.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Limitation of Liability</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                {companyInfo.name} shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use this website or its services.
              </p>
              <p className="text-slate-600 leading-relaxed mb-4">
                We make no warranties or representations about the accuracy or completeness of the content on this website or the content of any sites linked to this website.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Indemnification</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                You agree to indemnify and hold harmless {companyInfo.name}, its officers, directors, employees, and agents from any claims, damages, losses, or expenses arising out of your use of this website or violation of these Terms of Service.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Governing Law</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                These Terms of Service shall be governed by and construed in accordance with the laws of the State of North Carolina, without regard to its conflict of law provisions. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts located in North Carolina.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">10. Changes to Terms</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                {companyInfo.name} reserves the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to this website. Your continued use of the website following the posting of changes constitutes your acceptance of such changes.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">11. Contact Information</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li><strong>Phone:</strong> {companyInfo.phone}</li>
                <li><strong>Contact Form:</strong> <a href="/contact" className="text-cyan-600 hover:underline">Contact Us</a></li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
